import React from 'react';
import { X } from 'lucide-react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { vscDarkPlus } from 'react-syntax-highlighter/dist/esm/styles/prism';

export const HookDrawer = ({ hook, isOpen, onClose }) => {
  if (!hook) return null;

  return (
    <>
      <div
        className={`drawer-overlay ${isOpen ? 'open' : ''}`}
        onClick={onClose}
      />
      <div className={`hook-drawer ${isOpen ? 'open' : ''}`}>
        <div className="drawer-header">
          <div>
            <h2 className="drawer-title">{hook.name}</h2>
            <p className="drawer-signature">{hook.signature}</p>
          </div>
          <button className="drawer-close" onClick={onClose}>
            <X className="w-6 h-6" />
          </button>
        </div>

        <div className="drawer-content">
          <div className="drawer-section">
            <h3 className="section-title">Description</h3>
            <p className="section-text">{hook.description}</p>
          </div>

          <div className="drawer-section">
            <h3 className="section-title">Example Usage</h3>
            <div className="markdown-content">
              <SyntaxHighlighter
                language="typescript"
                style={vscDarkPlus}
                customStyle={{
                  borderRadius: '12px',
                  padding: '20px',
                  fontSize: '13px',
                  margin: 0,
                }}
              >
                {hook.example}
              </SyntaxHighlighter>
            </div>
          </div>

          <div className="drawer-section">
            <h3 className="section-title">Full Documentation</h3>
            <div className="markdown-content">
              <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                components={{
                  code({ node, inline, className, children, ...props }) {
                    const match = /language-(\w+)/.exec(className || '');
                    return !inline && match ? (
                      <SyntaxHighlighter
                        style={vscDarkPlus}
                        language={match[1]}
                        PreTag="div"
                        customStyle={{
                          borderRadius: '8px',
                          padding: '16px',
                          fontSize: '13px',
                          margin: '12px 0',
                        }}
                        {...props}
                      >
                        {String(children).replace(/\n$/, '')}
                      </SyntaxHighlighter>
                    ) : (
                      <code className="inline-code" {...props}>
                        {children}
                      </code>
                    );
                  },
                  h1: ({ children }) => <h1 className="markdown-h1">{children}</h1>,
                  h2: ({ children }) => <h2 className="markdown-h2">{children}</h2>,
                  h3: ({ children }) => <h3 className="markdown-h3">{children}</h3>,
                  p: ({ children }) => <p className="markdown-p">{children}</p>,
                  ul: ({ children }) => <ul className="markdown-ul">{children}</ul>,
                  ol: ({ children }) => <ol className="markdown-ol">{children}</ol>,
                  li: ({ children }) => <li className="markdown-li">{children}</li>,
                  table: ({ children }) => (
                    <div className="markdown-table-wrapper">
                      <table className="markdown-table">{children}</table>
                    </div>
                  ),
                  thead: ({ children }) => <thead className="markdown-thead">{children}</thead>,
                  tbody: ({ children }) => <tbody className="markdown-tbody">{children}</tbody>,
                  tr: ({ children }) => <tr className="markdown-tr">{children}</tr>,
                  th: ({ children }) => <th className="markdown-th">{children}</th>,
                  td: ({ children }) => <td className="markdown-td">{children}</td>,
                  blockquote: ({ children }) => <blockquote className="markdown-blockquote">{children}</blockquote>,
                }}
              >
                {hook.documentation}
              </ReactMarkdown>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};